import { useCallback } from "react";
import { useShallowSidebarStore } from "../store/sidebar-store";

export const useUpdateEnduserInSidebar = () => {
  const { contentType, contentTypeData, isOpen, openSidebar } = useShallowSidebarStore(
    "isOpen",
    "contentTypeData",
    "contentType",
    "openSidebar"
  );

  const updateEnduserInSidebar = useCallback(
    (enduserId: string | undefined) => {
      if (!isOpen) return;
      if (!enduserId) return;
      if (contentType !== "ContactDetails") return;
      if (contentTypeData.ContactDetails?.enduserId === enduserId) return;
      openSidebar("ContactDetails", {
        enduserId,
        selectedSection: contentTypeData.ContactDetails?.selectedSection ?? "Information",
      });
    },
    [
      contentType,
      contentTypeData.ContactDetails?.enduserId,
      contentTypeData.ContactDetails?.selectedSection,
      isOpen,
      openSidebar,
    ]
  );

  return updateEnduserInSidebar;
};
